import { Box, Button, Heading, Input, Text, useToast } from "@chakra-ui/react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { login } from "../../src/api";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const { login: saveToken } = useAuth(); // context login 함수
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const toast = useToast();

  const handleJoin = () => navigate("/join");

  const handleLogin = async () => {
    if (!email || !password) {
      toast({
        title: "입력 오류",
        description: "이메일과 비밀번호를 모두 입력해주세요.",
        status: "warning",
        duration: 2000,
        isClosable: true,
      });
      return;
    }

    setLoading(true);
    try {
      const res = await login(email, password);

      const success = res?.data?.success;
      const accessToken = res?.data?.data?.accessToken; // 수정
      const user = res?.data?.data?.user;

      if (success && accessToken) {
        // 토큰 저장
        saveToken(accessToken, user);

        // 원한다면 user 정보도 저장 가능
        localStorage.setItem("user", JSON.stringify(user));

        navigate("/member");
      } else {
        toast({
          title: "로그인 실패",
          description: res?.data?.message || "로그인에 실패했습니다.",
          status: "error",
          duration: 2000,
          isClosable: true,
        });
      }
    } catch (e) {
      toast({
        title: "서버 오류",
        description: "이메일 또는 비밀번호가 올바르지 않습니다.",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      minH="100vh"
      bgGradient="linear(to-b, white, blue.50)"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        w="632px"
        h="424px"
        bg="white"
        p="40px"
        borderRadius="20px"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="flex-start"
        boxShadow="lg"
      >
        <Heading fontFamily="Pretendard" fontSize="24px" mb="40px">
          로그인
        </Heading>

        <Box w="100%" display="flex" flexDirection="column">
          <form
            style={{ display: "flex", flexDirection: "column" }}
            onSubmit={(e) => {
              e.preventDefault();
              handleLogin();
            }}
          >
            <Input
              h="46px"
              mb="20px"
              placeholder="이메일 주소"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Input
              h="46px"
              placeholder="비밀번호"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <Box display="flex" justifyContent="space-between" alignItems="center" mt="20px">
              <Link to="/forgot-password">
                <Text fontSize="12px" color="blue.500" _hover={{ textDecoration: "underline" }}>
                  비밀번호 찾기
                </Text>
              </Link>
              <Button
                fontFamily="Pretendard"
                fontSize="12px"
                color="white"
                backgroundColor="#0054C0"
                w="57px"
                h="24px"
                onClick={handleJoin}
              >
                회원가입
              </Button>
            </Box>

            <Button
              type="submit"
              isLoading={loading}
              fontFamily="Pretendard"
              fontSize="16px"
              color="white"
              backgroundColor="#0054C0"
              w="161px"
              h="54px"
              mt="20px"
              alignSelf="center"
              onClick={handleLogin}
            >
              로그인
            </Button>
          </form>
        </Box>
      </Box>
    </Box>
  );
}
